import React, { forwardRef } from 'react';

import MUIDivider, {
  DividerProps as MUIDividerProps,
} from '@material-ui/core/Divider';

interface DividerProps extends MUIDividerProps {}

const Divider = forwardRef<HTMLHRElement, DividerProps>((props, ref) => {
  return <MUIDivider {...props} ref={ref} />;
});

Divider.displayName = 'Divider';

export default Divider;
